/// <amd-module name="typeahead/core/util/Optional"/>

export class Optional<T> {

    public static of<T>(value: T): Optional<T> {
        if (Optional.isEmpty(value)) {
            throw ("Optional.of() does not accept undefined or null as argument");
        }
        return new Optional<T>(value);
    }

    public static ofNullable<T>(value: T): Optional<T> {
        return new Optional<T>(value);
    }

    public static empty<T>(): Optional<T> {
        return new Optional<T>(null);
    }

    private static isEmpty<T>(value: T): boolean {
        return (value === undefined || value === null);
    }

    private value: T;

    constructor(value: T) {
        this.value = value;
    }

    public get(): T {
        if (this.isPresent()) {
            return this.value;
        }
        throw new Error("trying to get the value of an empty Optional");
    }

    public isPresent(): boolean {
        return ! Optional.isEmpty(this.value);
    }

    public orElse(alternative: T): T {
        if (this.isPresent()) {
            return this.value;
        } else {
            return alternative;
        }
    }
}
